import CollectionOptionsConnector from './collectionOptions.props';
import CollectionOptionsComponent from './collectionOptions.component';

export default CollectionOptionsConnector(CollectionOptionsComponent);
